import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const AltaColaboradorProcedimiento = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/alta-nuevo-colaborador-proceso.pdf`;
  /*const pdfUrl = "/pdf/alta-nuevo-colaborador-proceso.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Solicitud de Alta de Colaborador</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Solicitud de Alta de Colaborador" />
      </Container>
    </>
  );
};

 export default AltaColaboradorProcedimiento;
